module.exports = __webpack_public_path__ + "static/tob_icon.ec16676f.png";